export const zbpIconNames = {
  arrow_right: 'arrow_right',
  arrow_chevron_right: 'arrow_chevron_right',
  arrow_chevron_left: 'arrow_chevron_left',
  arrow_chevron_up: 'arrow_chevron_up',
  arrow_chevron_down: 'arrow_chevron_down',
  smileyFace: 'smileyFace',
  thumbtack: 'thumbtack',
  printer: 'printer',
  x_cross: 'x_cross',
  x_cross_circle: 'x_cross_circle',
  t_cross: 't_cross',
  flip: 'flip',
  pencil: 'pencil',
  ellipse: 'ellipse',
  eye: 'eye',
  exclamation_in_circle: 'exclamation_in_circle',
  custom_card: 'custom_card',
  download: 'download',
  neutral: 'neutral',
  backArrow: 'backArrow',
  camera: 'camera',
  calendar_blank: 'calendar_blank',
  calendar_go_to_today: 'calendar_go_to_today',
  copy: 'copy',
  paste: 'paste',
  vertical_ellipses: 'vertical_ellipses',
  check_mark: 'check_mark',
  check_circle: 'check_circle',
  check_circle_inverted: 'check_circle_inverted',
  trash_can: 'trash_can',
  key_glow: 'key_glow',
  key_horizontal: 'key_horizontal',
  cog: 'cog',
  cog2: 'cog2',
  mask: 'mask',
  notepad: 'notepad',
  notepadWithT: 'notepadWithT',
  envelope: 'envelope',
  delete_all: 'delete_all',
  export: 'export',
  upload: 'upload',
  file: 'file',
  grid: 'grid',
  info_circle: 'info_circle',
  info_circle_inverted: 'info_circle_inverted',
  unchecked_box: 'unchecked_box',
  checked_box: 'checked_box',
  move_handle: 'move_handle',
  resize_handle: 'resize_handle',
  wrenches: 'wrenches',
  parent_role: 'parent_role',
  admin_teacher_role: 'admin_teacher_role',
  speaker_icon: 'speaker_icon',
  student_role: 'student_role',
  admin_area: 'admin_area',
  cx_admin_area: 'cx_admin_area',
  district_admin_area: 'district_admin_area',
  school_admin_area: 'school_admin_area',
  support_area: 'support_area',
  teacher_area: 'teacher_area',
  parent_area: 'parent_area',
  import_file: 'import_file',
  qr_code_scan: 'qr_code_scan',
  qr_code_new: 'qr_code_new',
  hamburger: 'hamburger',
  caret_down: 'caret_down',
  question_mark: 'question_mark',
  zb_logo: 'zb_logo',
  classroom: 'classroom',
  open_book: 'open_book',
  logout: 'logout',
  clear: 'clear',
  navigateToFolder: 'navigateToFolder',
  fileTransfer: 'fileTransfer',
  uploadIcon: 'uploadIcon',
  magnifyingGlassWithMinusIcon: 'magnifyingGlassWithMinusIcon',
  magnifyingGlassWithPlusIcon: 'magnifyingGlassWithPlusIcon',
  eraserIcon: 'eraserIcon',
  pencilDrawIcon: 'pencilDrawIcon',
  audioNextIcon: 'audioNextIcon',
  audioPreviousIcon: 'audioPreviousIcon',
  audioPlayIcon: 'audioPlayIcon',
  audioPauseIcon: 'audioPauseIcon',
  audioRewindIcon: 'audioRewindIcon',
  audioFastForwardIcon: 'audioFastForwardIcon',
  warningCircleIcon: 'warningCircleIcon',
};
